import Newsletter from './components';

export default Newsletter;
